<template>
  <v-container class="account-page flex-row d-flex">
    <div class="pr-4">
      <v-img
        :src="formData.photoURL || placeholderURL"
        :lazySrc="placeholderURL"
        aspect-ratio="1"
        class="grey lighten-2 mb-4"
        width="150"
        height="150"
      ></v-img>
    </div>
    <div class="flex-grow-1">
      <h4 class="mb-4 title">My Account</h4>
      <form @submit.prevent="submit">
        <v-text-field
          v-model="formData.email"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
          label="Email"
          data-vv-name="email"
          required readonly
        ></v-text-field>
        <v-text-field
          v-model="formData.displayName"
          v-validate="'min:3'"
          :error-messages="errors.collect('Name')"
          label="Name"
          data-vv-name="Name"
        ></v-text-field>
        <v-text-field
          v-model="formData.phoneNumber"
          v-validate="'digits:10'"
          :error-messages="errors.collect('phoneNumber')"
          label="Phone Number"
          data-vv-name="phoneNumber"
        ></v-text-field>
        <v-text-field
          v-model="formData.photoURL"
          :error-messages="errors.collect('photoURL')"
          label="Photo URL"
          data-vv-name="photoURL"
        ></v-text-field>
        <v-switch
          readonly
          v-model="formData.emailVerified"
          :label="`Email verification: ${formData.emailVerified?'Completed':'Pending'} `"
        ></v-switch>
        <div class="mt-5">
          <v-btn depressed color="accent" type="submit">Update Account</v-btn>
        </div>
      </form>
    </div>
  </v-container>
</template>

<style scoped>
.container {
  max-width: 800px;
  margin-left: 0;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'account-page',
  $_veeValidate: {
    validator: 'new',
  },

  data: () => ({
    formData: {
      email: '',
      displayName: '',
      photoURL: '',
      emailVerified: false,
      phoneNumber: null,
    },
    isvalid: false,
    dictionary: {
      attributes: {
        phoneNumber: 'Phone Number',
        photoURL: 'Photo URL',
      },
    },
  }),

  computed: {
    ...mapState([
      'placeholderURL',
    ]),
  },

  mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    ...mapActions('db', {
      updateUser: types.UPDATE_AND_SYNC_USER,
    }),
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log('form', this.formData);
          this.updateUser(this.formData);
        }
      });
    },
    clear() {
      this.$validator.reset();
    },
  },

  created() {
    const {
      uid,
      email,
      displayName,
      photoURL,
      emailVerified,
      phoneNumber,
    } = this.$store.state.user;
    this.formData = {
      uid,
      email,
      displayName,
      photoURL,
      emailVerified,
      phoneNumber,
    };
  },
};
</script>
